import React from "react";
import { Button, Col, Row } from "antd";
import { useSelector } from "react-redux";
import { FaQrcode } from "react-icons/fa6";
import { useDispatch } from "react-redux";
import ClientScanTab from "./client_scan_tab";
import {
  defaultClientInfoSelector,
  defaultClientTypeSelector,
} from "store/user/(default)/client/default_client.selector";
import { setDefaultClientType } from "store/user/(default)/client/default_client.action";

//
//component
//redux
//selector
//actions
//utils
//hook
//str
const ClientScan = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const clientInfo = useSelector(defaultClientInfoSelector);
  const type = useSelector(defaultClientTypeSelector);
  const enabled = !clientInfo && type === "qr";
  // -------------------------- FUNCTION ------------------------

  const handleSwitchQR = () => {
    dispatch(setDefaultClientType("email"));
  };

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const QRButton = () => {
    return (
      <Button
        onClick={handleSwitchQR}
        icon={
          <span className="anticon">
            <FaQrcode />
          </span>
        }
        type="link"
      >
        Tìm kiếm email
      </Button>
    );
  };

  const renderQRScan = () => {
    return (
      <Row>
        <Col xl={24} lg={24} md={24} xs={24}>
          <ClientScanTab />
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN ----------------------------
  if (!enabled) return null;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span style={{ fontWeight: "bold" }}>Tìm kiếm theo mã QR</span>
        <QRButton />
      </div>
      {renderQRScan()}
    </div>
  );
};
export default ClientScan;
